module.exports = __webpack_public_path__ + "img/electricMotorcycle-blue.5a213d2b.svg";